<template>
  <div>
    <!-- Text Input -->
    <template v-if="type === 'text'">
      <TextField
        :field-validator="fieldValidator"
        :label="label"
        :placeholder="placeholder"
        :id="id"
        :name="name"
        :required="required"
        :disabled="disabled"
        :styles="styles"
        :value="value"
        :limit="limit"
        @input-change="onInputChange"
        @error-change="$emit('error-change', $event)"
      ></TextField>
    </template>

    <!-- Select Input -->
    <template v-if="type === 'select'">
      <Select
        :label="label"
        :placeholder="placeholder"
        :id="id"
        :name="name"
        :required="required"
        :disabled="disabled"
        :styles="styles"
        :options="options"
        :selected="selected"
        :showSearchSelect="showSearchSelect"
        :showDefaultOption="showDefaultOption"
        :value="value"
        @input-change="onInputChange"
        @error-change="$emit('error-change', $event)"
      ></Select>
    </template>

    <!-- Textarea Input -->
    <template v-if="type === 'textarea'">
      <TextArea
        :label="label"
        :placeholder="placeholder"
        :id="id"
        :name="name"
        :required="required"
        :disabled="disabled"
        :styles="styles"
        :value="value"
        :limit="limit"
        @input-change="onInputChange"
        @error-change="$emit('error-change', $event)"
      ></TextArea>
    </template>

    <!-- Texteditor Input -->
    <template v-if="type === 'texteditor'">
      <TextEditor
        :label="label"
        :placeholder="placeholder"
        :id="id"
        :name="name"
        :required="required"
        :disabled="disabled"
        :styles="styles"
        :value="value"
        :limit="limit"
        @input-change="onInputChange"
        @error-change="$emit('error-change', $event)"
      ></TextEditor>
    </template>
  </div>
</template>

<script>
import TextField from '@/components/DesignSystem/Inputs/TextField';
import Select from '@/components/DesignSystem/Inputs/Select';
import TextArea from '@/components/DesignSystem/Inputs/TextArea';
import TextEditor from '@/components/DesignSystem/Inputs/TextEditor';
export default {
  name: 'Input',
  components: {
    TextField,
    Select,
    TextArea,
    TextEditor,
  },
  props: {
    fieldValidator: {
      type: Function,
      default: () => {
        false;
      },
    },
    options: {
      type: Array,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    selected: {
      default: 'default',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: '',
    },
    styles: {
      type: String,
      default: '',
    },
    showSearchSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showDefaultOption: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onInputChange($event) {
      this.$emit('input', $event.value);
      this.$emit('input-change', $event);
    },
  },
};
</script>
